<div class="contact-information-modal">
  <header class="modal__header">
    <h2 id="modalLabel">{{ 'contact_form.label.check_your_information' | translate }}</h2>
    <button type="button" class="button modal__button--close" (click)="closeModal()" [attr.aria-label]="'general.label.close' | translate">
      <i class="icon icon-ui-close--sm"></i>
    </button>
  </header>
  <div class="modal__content">
    <air-form
      #formComponent
      [controls]="form"
      (submitted)="submitValues($event)"
      [showMandatory]="true"
      [disabled]="formDisabled"
      [showInvalidToast]="true"
      [userEventSource]="userEventSource"
    >
      <div class="modal__footer--full-width">
        <button
          type="button"
          class="button form__button button--cta"
          [airButtonLoading]="isSubmitting"
          [disabled]="formDisabled"
          (click)="submit($event)"
        >
          <span>{{ 'general.label.send' | translate }}</span>
        </button>
      </div>
    </air-form>
  </div>
</div>
